import React, { useState, useEffect } from "react";
import AddIcon from "@mui/icons-material/Add";
import TablePagination from "@mui/material/TablePagination";
import Modal from "@mui/material/Modal";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CustomLoading from "../../shared/utils/CustomLoading";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import GlobalSnackbar from "../../shared/utils/GlobalSnackbar";

import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import { useNavigate } from "react-router-dom";

import {
  Box,
  Table,
  TableCell,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Tooltip,
  IconButton,
  Pagination,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Menu,
  Avatar,
  Chip,
  TextField,
  InputAdornment,
} from "@mui/material";
import Stack from "@mui/material/Stack";
import SearchIcon from "@mui/icons-material/Search";

import ClientOnboardingform from "../../shared/createForms/ClientOnboarding";

import axios from "axios";
import { ViewIcon } from "../../shared/assets/icons/index";
import FormatTimestamp from "../../helperFunctions/FormatDateTimestamp";
import Swal from "sweetalert2";
import styles from "../../styles/adminPortal.module.css";
import DeletedUsersRestore from "../../shared/createForms/DeletedUsersRestore";
import GlobalButton from "../../shared/utils/GlobalButton";

// import ImportExport from "./ImportExport";
const columns = [
  {
    field: "company",
    headerName: "COMPANY NAME",
    width: 280,
  },
  {
    field: "sector",
    headerName: "SECTOR",
    width: 140,
  },
  {
    field: "location",
    headerName: "LOCATION",
    width: 180,
  },
  {
    field: "contact",
    headerName: "CONTACT INFO",
    width: 220,
  },
  {
    field: "onboardedby",
    headerName: "ADDED BY",
    width: 180,
  },
  {
    field: "owner",
    headerName: "ORG. OWNER",
    width: 180,
  },
  {
    field: "campaign",
    headerName: "TOTAL CAMPAIGNS",
    width: 140,
  },
  {
    field: "action",
    headerName: "ACTION",
    width: 80,
  },
];

export default function CustomTable() {
  // const [page, setPage] = React.useState(0);
  const userId = localStorage.getItem("userId");
  const [rowsPerPage, setRowsPerPage] = React.useState(5); // Rows per page
  const [selected, setSelected] = React.useState([]); // State for selected rows
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isActionLoading, setIsActionLoading] = useState(false);
  const [isTrashModalOpen, setIsTrashModalOpen] = useState(false);
  const [allDeletedClients, setALLDeletedClient] = useState([]);
  const [isTrashLoading, setTrashLoading] = useState(false);
  const [OrganizationListLoading, setOrganizationListLoading] = useState(true);
  const [pageSize, setPageSize] = useState(20);
  const pageSizeOptions = [1, 5, 10, 20, 50, 100];
  const [page, setPage] = useState(1);
  const [searchValue, setSearchValue] = useState("");

  const [sectorFilter, setSectorFilter] = useState("");

  const sectorList = [
    "Retail",
    "Healthcare",
    "IT",
    "Education",
    "Finance",
    "Manufacturing",
  ];
  const [totalPages, setTotalPages] = useState(1);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRowId, setSelectedId] = useState(null);
  const [open, setOpen] = React.useState(false);
  const [selectedCompany, setSelectedCompany] = useState([]);
  const [totalClient, setTotalClient] = useState("0");

  let role = localStorage.getItem("role");
  const [allDetails, setAllDetails] = useState([]);

  const [searchInputs, setSearchInputs] = useState({
    companyName: "",
    city: "",
    contactNumber: "",
    sector: "",
    addedBy: userId,
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  let debounceTimeout = null;
  const navigate = useNavigate();

  const [isCompanyDetailsModal, setIsCompanyDetailsModal] = useState(false);
  const serverURL = process.env.REACT_APP_URL;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleOpen = () => setOpen(true);

  const handleClose = () => {
    setOpen(false);
    setAnchorEl(null);
    setSelectedId(null);
  };
  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleModalOpen = (value) => {
    setIsModalOpen(value);
  };

  const fetchCompanyData = async (page = 1, limit = 20) => {
    try {
      const token = localStorage.getItem("token");
      const queryParams = new URLSearchParams({
        page,
        limit,
        addedBy: userId, // Add userId to filter by the user who added the organization
      });
      const response = await axios.get(
        `${serverURL}/organization/view?${queryParams.toString()}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response?.data?.success) {
        setTotalClient(response?.data?.totalOrganizations);
        // setTotalCompanies(response?.data?.totalOrganizations); // Assuming totalOrganizations is returned from backend
        setAllDetails(response?.data?.data); // Assuming this holds paginated organization data
        oldData = response?.data?.data; // Save current data to oldData
        setTotalPages(response?.data?.totalPages); // Assuming totalPages is returned from backend
        setOrganizationListLoading(false);
      }
    } catch (error) {
      console.error("Error fetching companies:", error);
    }
  };
  const getALLDeletedClients = async () => {
    try {
      setTrashLoading(true);
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${serverURL}/organization/allDeletedOrganizations`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      if (response?.data?.success) {
        setALLDeletedClient(response?.data?.data);
      }
    } catch (error) {
      console.error("Error fetching InstallationPartner:", error);
    } finally {
      setTrashLoading(false);
    }
  };

  const handlePageSizeChange = async (event) => {
    const newSize = parseInt(event.target.value, 10);
    setPageSize(newSize);

    const queryParams = new URLSearchParams();

    Object.entries(searchInputs).forEach(([key, searchValue]) => {
      if (searchValue.trim() !== "") {
        queryParams.append(key, searchValue);
      }
    });

    queryParams.append("page", 1);
    queryParams.append("limit", newSize);

    await fetchClients(queryParams.toString());
  };
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (anchorEl && !anchorEl.contains(e.target)) {
        handleClose();
      }
    };

    window.addEventListener("click", handleClickOutside);

    // Cleanup event listener when component unmounts or menu is closed
    return () => {
      window.removeEventListener("click", handleClickOutside);
    };
  }, [anchorEl]);

  useEffect(() => {
    fetchCompanyData();
  }, []);

  const handleClick = (event, rowId) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setSelectedId(rowId);
  };

  const handleRowClick = async (rowId) => {
    setIsActionLoading(true);

    try {
      const response = await axios.get(
        `${serverURL}/organization/view/${rowId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      if (response.data.success) {
        setSelectedCompany(response.data);
        setIsCompanyDetailsModal(true);
      }
      setIsActionLoading(false);
    } catch (error) {
      console.error("Error fetching company:", error);
      setIsActionLoading(false);
    }
  };

  // const handleEditModal = async (e, v) => {
  //   e.stopPropagation();
  //   setAnchorEl(null);
  //   setIsActionLoading(true);

  //   try {
  //     const response = await axios.get(`${serverURL}/organization/view/${v}`, {
  //       headers: {
  //         Authorization: `Bearer ${localStorage.getItem("token")}`,
  //       },
  //     });

  //     if (response.data.success) {
  //       setSelectedCompany(response.data);
  //     }
  //     setIsActionLoading(false);

  //     setIsCompanyDetailsModal(true);
  //   } catch (error) {
  //     console.error("Error fetching company:", error);
  //   }
  // };

  const handleEditModal = (e, organizationId) => {
    e.stopPropagation();
    setAnchorEl(null);

    navigate(`view/${organizationId}`);
  };
  const handlePageChange = async (e, value) => {
    setPage(value); // Update the page state

    // Prepare the query params with the current search state
    const queryParams = new URLSearchParams();

    // Loop over the search inputs and add the search parameters to the query
    Object.entries(searchInputs).forEach(([key, searchValue]) => {
      if (searchValue.trim() !== "") {
        queryParams.append(key, searchValue);
      }
    });

    // Add the new page and page size to the query params
    queryParams.append("page", value);
    queryParams.append("limit", pageSize); // Assuming pageSize is the number of items per page

    // Call the API with the query params
    await fetchClients(queryParams.toString());
  };

  const DeleteHandle = async (id) => {
    setAnchorEl(null);

    Swal.fire({
      customClass: {
        container: "my-swal",
      },
      icon: "warning",
      text: "Do you want to delete?",
      showCancelButton: true,
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          // Perform the delete operation
          const response = await axios.delete(
            `${serverURL}/organization/delete/${id}`,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            },
          );

          if (response.data.success) {
            setSnackbar({
              open: true,
              message: response.data.message,
              severity: "success",
            });
            fetchCompanyData();
            setAnchorEl(null);
          }
        } catch (error) {
          console.error("Error during deletion:", error);
          Swal.fire({
            icon: "error",
            text: error.response?.data?.message || "An error occurred",
            color: "black",
          });
        }
      }
      setAnchorEl(null);
    });
  };
  const fetchClients = async (queryParams) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${serverURL}/organization/view?${queryParams}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      if (response?.data?.success) {
        setPage(response?.data?.currentPage);

        setAllDetails(response?.data?.data); // Assuming this holds paginated organization data
        setTotalPages(response?.data?.totalPages); // Assuming totalPages is returned from backend
        setOrganizationListLoading(false);
      }
    } catch (error) {
      console.error("Error fetching filtered vendors:", error);
    } finally {
    }
  };
  const handleSearchChangeHead = async (e, key) => {
    let queryParam = new URLSearchParams();
    const value = e.target.value;

    setSearchInputs((prevState) => {
      const updatedInputs = { ...prevState, [key]: value };

      // Check if all search fields are empty, reset to full API fetch
      const allFieldsEmpty = Object.values(updatedInputs).every(
        (val) => val.trim() === "",
      );

      if (allFieldsEmpty) {
        fetchCompanyData(1, pageSize);
        return updatedInputs;
      }

      // Clear previous timeout before setting a new one
      if (debounceTimeout) clearTimeout(debounceTimeout);

      // Set a new timeout of 3 seconds before sending the API request
      // debounceTimeout = setTimeout(() => {
      // Construct API Query Parameters based on filled fields
      let queryParams = new URLSearchParams();

      Object.entries(updatedInputs).forEach(([searchKey, searchValue]) => {
        if (searchValue.trim() !== "") {
          queryParams.append(searchKey, searchValue);
        }
      });

      // Add pagination info (page and limit) to the queryParams
      queryParams.append("page", 1); // Current page
      queryParams.append("limit", pageSize); // Number of rows per page

      // Call API with filtered search parameters after 3 seconds
      fetchClients(queryParams.toString());
      // }, 1000); // Delay of 3000ms (3 seconds)

      return updatedInputs;
    });
  };

  const handleTrashOpen = () => {
    getALLDeletedClients();
    setIsTrashModalOpen(true);
  };
  return (
    <div
      style={{
        background: "#F8FAFC",
        padding: "24px",
      }}
    >
      <Box
        sx={{
          maxWidth: "1600px",
          margin: "auto",
        }}
      >
        {!OrganizationListLoading ? (
          <>
            <div className="flex justify-between items-center mb-4">
              <div>
                <div className="flex items-center gap-2">
                  <Typography className="font-semibold text-lg">
                    Client Directory
                  </Typography>

                  <Chip
                    label={totalClient}
                    fontSize="12px"
                    sx={{
                      bgcolor: "#DCE1FF",
                      color: "#00164E",
                      fontWeight: 700,
                      height: 22,
                    }}
                  />
                </div>
              </div>

              <div className="flex items-center gap-2">
                {localStorage.getItem("role") === "-1" && (
                  <Tooltip title="Trash">
                    <IconButton onClick={handleTrashOpen}>
                      <DeleteOutlinedIcon />
                    </IconButton>
                  </Tooltip>
                )}

                <GlobalButton
                  variant="primary"
                  size="medium"
                  leftIcon={<AddIcon />}
                  onClick={() =>
                    navigate("/adminportal/clientDetails/add/details")
                  }
                >
                  {`Add Client`}
                </GlobalButton>
              </div>
            </div>
            <Paper
              elevation={0}
              sx={{
                borderRadius: "20px",
                overflow: "hidden",
                border: "1px solid #E5E7EB",
                background: "#fff",
              }}
            >
              <EnhancedTableToolbar
                totalClient={totalClient}
                searchInputs={searchInputs}
                handleSearch={handleSearchChangeHead}
                getALLDeletedClients={getALLDeletedClients}
              />

              <TableContainer
                sx={{
                  borderRadius: 1,
                  background: "#fff",
                  overflow: "auto",
                  maxHeight: "60vh",
                }}
              >
                <Table stickyHeader aria-label="customized table">
                  <TableHead>
                    <TableRow>
                      {columns.map((column) => (
                        <TableCell
                          key={column.field}
                          sx={{
                            minWidth: column.width,

                            position: "sticky",
                            top: 0,
                            zIndex: 100,

                            background: "#F2F2F2",
                            color: "#384761",

                            fontWeight: 700,

                            fontSize: 12,

                            borderBottom: "1px solid #E5E7EB",
                          }}
                        >
                          {column.headerName}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  {allDetails && allDetails.length > 0 ? (
                    <TableBody>
                      {allDetails?.map((row, index) => (
                        <TableRow
                          key={row?.organizationDetail?._id}
                          hover
                          sx={{
                            transition: ".25s",
                            "&:hover": {
                              background: "#F8FAFC",
                            },
                          }}
                        >
                          {/* Company */}

                          <TableCell>
                            <Stack
                              direction="row"
                              spacing={2}
                              alignItems="center"
                            >
                              <Avatar
                                src={row.organizationDetail.brandLogo}
                                sx={{
                                  width: 48,
                                  height: 48,
                                  bgcolor: "#2563EB",
                                }}
                              >
                                {!row.organizationDetail.brandLogo &&
                                  row.organizationDetail.name.charAt(0)}
                              </Avatar>

                              <Box>
                                <Typography
                                  sx={{
                                    fontWeight: 600,
                                    fontSize: 18,
                                    color: "#00236f",
                                  }}
                                >
                                  {row.organizationDetail.name}
                                </Typography>

                                <Typography
                                  variant="body2"
                                  sx={{
                                    color: "#444651",
                                    fontSize: 12,
                                    fontWeight: 500,
                                  }}
                                >
                                  ID :{row.organizationDetail._id.slice(-8)}
                                </Typography>
                              </Box>
                            </Stack>
                          </TableCell>

                          {/* Sector */}

                          <TableCell>
                            <div
                              style={{
                                backgroundColor: "rgb(248 250 249)",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                padding: "2px",
                              }}
                            >
                              <p
                                style={{
                                  color: "#27c38a",
                                  fontWeight: 500,
                                  fontSize: "12px",
                                }}
                                // className="px-2 py-1 rounded text-white text-xs"
                              >
                                {row.organizationDetail.sector}
                              </p>
                            </div>
                          </TableCell>

                          {/* Location */}

                          <TableCell>
                            <Typography
                              fontWeight={400}
                              fontSize={14}
                              color={"#191c1e"}
                            >
                              {row.organizationDetail.city}
                            </Typography>
                          </TableCell>

                          {/* Contact */}
                          <TableCell>
                            <Typography
                              fontWeight={400}
                              fontSize={14}
                              color={"#191c1e"}
                            >
                              {row.organizationDetail.client?.phoneNumber}
                            </Typography>

                            <Typography
                              fontWeight={500}
                              fontSize={12}
                              color={"#444651"}
                            >
                              {row.organizationDetail.client?.emailAddress}
                            </Typography>
                          </TableCell>
                          {/* Owner */}

                          <TableCell>
                            <Typography
                              fontWeight={400}
                              fontSize={14}
                              color={"#191c1e"}
                            >
                              {row.organizationDetail.addedBy?.name}
                            </Typography>

                            <Typography
                              fontWeight={500}
                              fontSize={12}
                              color={"#444651"}
                            >
                              <FormatTimestamp
                                timestamp={row.organizationDetail.createdAt}
                              />
                            </Typography>
                          </TableCell>
                          <TableCell>
                            <Typography
                              fontWeight={400}
                              fontSize={14}
                              color={"#191c1e"}
                            >
                              {row.clientUsers?.find((u) => u.userRoleId === 1)
                                ?.name || "N/A"}
                            </Typography>
                          </TableCell>

                          {/* Campaign Count */}

                          <TableCell align="center">
                            <Typography
                              fontWeight={400}
                              fontSize={14}
                              color={"#191c1e"}
                            >
                              {row?.organizationDetail?.campainCount || "0"}
                            </Typography>
                          </TableCell>

                          {/* Action */}

                          <TableCell align="center">
                            <IconButton
                              onClick={(e) =>
                                handleClick(e, row.organizationDetail._id)
                              }
                            >
                              <MoreVertIcon />
                            </IconButton>

                            <Menu
                              anchorEl={anchorEl}
                              open={
                                Boolean(anchorEl) &&
                                selectedRowId === row.organizationDetail._id
                              }
                              onClose={handleClose}
                              PaperProps={{
                                sx: {
                                  borderRadius: 2,
                                  minWidth: 170,
                                },
                              }}
                            >
                              <MenuItem
                                onClick={(e) =>
                                  handleEditModal(e, row.organizationDetail._id)
                                }
                              >
                                <ViewIcon color="var(--para-color)" />

                                <Typography ml={1}>View</Typography>
                              </MenuItem>

                              {role == "-1" && (
                                <MenuItem
                                  onClick={() =>
                                    DeleteHandle(row.organizationDetail._id)
                                  }
                                  sx={{
                                    color: "error.main",
                                  }}
                                >
                                  <DeleteOutlinedIcon fontSize="small" />

                                  <Typography ml={1}>Delete</Typography>
                                </MenuItem>
                              )}
                            </Menu>
                          </TableCell>
                        </TableRow>
                      ))}

                      {allDetails?.length === 0 && (
                        <TableRow>
                          <TableCell
                            colSpan={7}
                            align="center"
                            sx={{
                              py: 8,
                            }}
                          >
                            <Typography color="text.secondary">
                              No Organization Found
                            </Typography>
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={columns?.length}
                        sx={{ borderBottom: "none" }}
                      >
                        <div className="flex justify-center items-center h-64">
                          No Organization Found
                        </div>
                      </TableCell>
                    </TableRow>
                  )}
                </Table>
              </TableContainer>
              <hr
                className="mt-2 bg-gray-200 "
                style={{ border: "0.5px solid var(--light-grey-color)" }}
              />
              <div className="flex items-center justify-between ">
                <FormControl
                  variant="standard"
                  size="small"
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 1,
                    "& .MuiInputBase-root:before": { borderBottom: "none" },
                    "& .MuiInputBase-root:after": { borderBottom: "none" },
                    "& .MuiInputBase-root": { marginTop: 1 }, // 👈 override here
                  }}
                >
                  <InputLabel
                    id="page-size-label"
                    sx={{
                      position: "static",
                      transform: "none",
                      fontSize: "14px",
                      marginRight: "8px",
                      marginLeft: "8px",
                      marginTop: "2px",
                    }}
                  >
                    Rows
                  </InputLabel>
                  <Select
                    labelId="page-size-label"
                    value={pageSize}
                    onChange={handlePageSizeChange}
                    label="Rows"
                  >
                    {pageSizeOptions.map((size, i) => (
                      <MenuItem key={i} value={size}>
                        {size}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <GlobalSnackbar
                  snackbar={snackbar}
                  handleClose={handleSnackbarClose}
                />
                <Pagination
                  className="p-2 flex justify-center"
                  count={totalPages}
                  page={page}
                  onChange={handlePageChange}
                  sx={{
                    "& .MuiPaginationItem-root.Mui-selected": {
                      backgroundColor: "#418cff", // Blue background for selected
                      color: "#fff", // White text for selected
                    },
                    "& .MuiPaginationItem-root.Mui-selected:hover": {
                      backgroundColor: "#3366cc", // Darker blue on hover
                    },
                    "& .MuiPaginationItem-root": {
                      "&:hover": {
                        backgroundColor: "#ddd", // Light gray for hovered items
                      },
                    },
                  }}
                />
              </div>

              {isActionLoading ? (
                <CustomLoading />
              ) : (
                isModalOpen && (
                  <ClientOnboardingform
                    setSnackbar={setSnackbar}
                    fetchCompanyData={fetchCompanyData}
                    isModalOpen={isModalOpen}
                    setIsModalOpen={setIsModalOpen}
                  />
                )
              )}
              {isActionLoading ? (
                <CustomLoading />
              ) : (
                isTrashModalOpen && (
                  <DeletedUsersRestore
                    list={allDeletedClients}
                    type="CLIENT"
                    openModal={isTrashModalOpen}
                    loading={isTrashLoading}
                    getAllDeletedUsers={getALLDeletedClients}
                    setIsTrashModalOpen={setIsTrashModalOpen}
                    setTrashLoading={setTrashLoading}
                    getAllList={fetchCompanyData}
                  />
                )
              )}
            </Paper>
          </>
        ) : (
          <div className={styles.tableLoading}>
            <CircularProgress />
          </div>
        )}
      </Box>
    </div>
  );
}
var oldData = [];

function EnhancedTableToolbar(props) {
  return (
    <>
      {/* Header */}

      {/* Search */}
      <div className="flex justify-between items-center px-4 py-3">
        <TextField
          placeholder="Search Client"
          value={props.searchInputs.companyName}
          onChange={(e) => props.handleSearch(e, "companyName")}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          sx={{
            width: 320,
            "& .MuiOutlinedInput-root": {
              height: 40,
              borderRadius: "8px",
            },
          }}
        />

        <FormControl sx={{ width: 180 }}>
          <Select
            displayEmpty
            value={props.searchInputs.sector}
            onChange={(e) => props.handleSearch(e, "sector")}
            sx={{
              height: 40,
              borderRadius: "8px",
            }}
          >
            <MenuItem value="">All Sectors</MenuItem>
            <MenuItem value="FMCG">FMCG</MenuItem>
            <MenuItem value="Agricultural">Agricultural</MenuItem>
            <MenuItem value="Automotive">Automotive </MenuItem>
            <MenuItem value="Banking & Finance">Banking & Finance</MenuItem>
            <MenuItem value="Hospitality & Travel">
              Hospitality & Travel
            </MenuItem>
            <MenuItem value="Entertainment & Media">
              Entertainment & Media
            </MenuItem>
            <MenuItem value="Healthcare">Healthcare</MenuItem>
            <MenuItem value="Textile Industry">Textile Industry</MenuItem>
            <MenuItem value="Energy">Energy</MenuItem>
            <MenuItem value="Tele Communication">Tele Communication</MenuItem>
          </Select>
        </FormControl>
      </div>
    </>
  );
}

var oldData = [];
